import { FormControlLabel, Slider, Switch } from "@mui/material";
import styles from "../../smartdevicedetails.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import SmartDeviceDetailsService from "../../smartdevicedetails.service";
import { useEffect, useState } from "react";

const Dimmercontroller = ({ smartDeviceData }) => {
    const { getAccessTokenSilently } = useAuth0();

    const [refreshComponent, setRefreshComponent] = useState(false);

    const valuetext = (value) => {
        return `${value}°C`;
    }

    const onStatusChange = async () => {
        try {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            smartDeviceData.status[0].value = !smartDeviceData.status[0].value;

            const payload = smartDeviceData.status[0];
            const headers = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            setRefreshComponent((s) => !s);
            await SmartDeviceDetailsService.onStatusChange(smartDeviceData.id, payload, headers);
        } catch (error) {
            console.log(error);
        }
    }

    const sliderHandler = (event, value) => {
        smartDeviceData.status[1].value = value;
        setRefreshComponent((s) => !s);
    }

    const onSliderChange = async (event, value) => {
        try {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const payload = smartDeviceData.status[1];
            const headers = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            setRefreshComponent((s) => !s);
            await SmartDeviceDetailsService.onStatusChange(smartDeviceData.id, payload, headers);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        console.log(refreshComponent);
    }, [refreshComponent]);

    return (<div className={`${styles.cardUnderS}`}>
        {!smartDeviceData?.online && (<div className={`${styles.OfflineSection}`}>
            <img src="/static/img/offline.svg" width="60px" height="60px" alt="" />
            <p>Device Is Offline</p>
        </div>)}
        {/* <p className={`${styles.ControllTitle}`} onClick={OpenController}>Control Panel<ChevronDown/></p> */}
        <div className={`${styles.WidgetIndi}`}>
            <p className={`${styles.WidgetT}`}>Switch</p>
            <div className={`${styles.OnOffSwitchSmartDE} OnOffSwitchSmartDE`}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={smartDeviceData.status[0].value}
                            onChange={onStatusChange}
                            name="checkedA"
                            inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                    }
                />
            </div>
        </div>
        <div className={`${styles.WidgetIndi}`}>
            <div className={smartDeviceData.status[0].value === true ? `` : `${styles.Disable}`}>
                <p className={`${styles.WidgetT}`}>Brightness</p>
                <p className={`${styles.WidgetTB}`}>{smartDeviceData?.status[1].value ? Math.round(smartDeviceData.status[1].value / 10) : 0}%</p>
            </div>
            <div className={
                smartDeviceData.status[0].value === true
                    ? `DimmerWidget`
                    : `DimmerWidget Disable ${styles.Disable}`
            }>
                <Slider
                    orientation="vertical"
                    getAriaValueText={valuetext}
                    value={smartDeviceData?.status[1].value}
                    aria-labelledby="vertical-slider"
                    min={10}
                    max={1000}
                    onChange={sliderHandler}
                    onChangeCommitted={onSliderChange}
                />
                <div className={`${styles.RangeLabel} RangeLabel`}>
                    <p className={`${styles.RangeLabelText} ${styles.Text100} Text100`}>100%</p>
                    <p className={`${styles.RangeLabelText} ${styles.Text75} Text75`}>75%</p>
                    <p className={`${styles.RangeLabelText} ${styles.Text50} Text50`}>50%</p>
                    <p className={`${styles.RangeLabelText} ${styles.Text25} Text25`}>25%</p>
                    <p className={`${styles.RangeLabelText} ${styles.Text0} Text0`}>0%</p>
                </div>
                <div className={`${styles.RangeIMG} RangeIMG`}>
                    <img src="/static/img/Range-mark.svg" className={`${styles.RangeMark}`} alt="" />
                    <img src="/static/img/Range-mark-D.svg" className={`${styles.RangeMarkD}`} alt="" />
                </div>
            </div>
        </div>
    </div>)
}

export default Dimmercontroller